/** Dates of the school day. Lessons are stored as ISO dates (YYYY-MM-DD) in the school's zone. */
export const SCHOOL_TIME_ZONE = 'Europe/Kyiv';

export function todayIso(now = new Date(), timeZone = SCHOOL_TIME_ZONE): string {
  // en-CA formats as YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', { timeZone }).format(now);
}

const toUtc = (iso: string) => new Date(`${iso}T00:00:00Z`);
const fromUtc = (d: Date) => d.toISOString().slice(0, 10);

export function addDays(iso: string, days: number): string {
  return fromUtc(new Date(toUtc(iso).getTime() + days * 86_400_000));
}

/** ISO weekday: 1 = Monday … 7 = Sunday. */
export function isoWeekday(iso: string): number {
  const day = toUtc(iso).getUTCDay();
  return day === 0 ? 7 : day;
}

/** Monday of the week the date belongs to. */
export function weekStart(iso: string): string {
  return addDays(iso, 1 - isoWeekday(iso));
}

export function weekDays(monday: string, count = 5): string[] {
  return Array.from({ length: count }, (_, i) => addDays(monday, i));
}

/** «08:30» in the school's zone. */
export function timeOf(timestamp: string, timeZone = SCHOOL_TIME_ZONE): string {
  return new Intl.DateTimeFormat('uk-UA', { timeZone, hour: '2-digit', minute: '2-digit' }).format(
    new Date(timestamp),
  );
}

/** «пн, 19 жовт.» */
export function shortDate(iso: string): string {
  return new Intl.DateTimeFormat('uk-UA', {
    timeZone: 'UTC',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  }).format(toUtc(iso));
}

/** «19.10» */
export function dayMonth(iso: string): string {
  return `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
}
